<div class="input-grid-gaps grid-6col container">
    <div class="fr-2">
        <app-text-input [disabled]="!userId()" [form]="formIdentity" prefix="ePrescriptions.checkReadiness."
            id="uuid"></app-text-input>
    </div>

    <div class="fr-2">
        <app-password-input [disabled]="!userId()" [form]="formIdentity" id="password"></app-password-input>
    </div>
    <div class="fr-2">
        <app-date-input [disabled]="!userId()" [form]="formIdentity" [timeType]="'endOfDay'"
            id="validTo"></app-date-input>
    </div>
</div>
